var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "uk-fieldset uk-margin"
  }, [(_vm.hasLegend) ? _c('legend', {
    staticClass: "uk-legend"
  }, [_vm._t("legend", [_vm._v("\n      " + _vm._s(_vm.legend) + "\n    ")])], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b209687","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/FormFieldset.vue
// module id = 1938
// module chunks = 0